import Vue from 'vue'
import Vuex from 'vuex'
import myPages from '@/router/pages'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    device: 0,
    viewWidth: 0,
    routeName: null,
    pages: myPages.pages,
    // windowWidth: document.documentElement.clientWidth,
    subPages: [],
    menuOpen: false,
    downloadOpen: false,
    isMobileMenu: false,
    content: [],
    videoOpen: false,
    videoSrc: null,
    headHeight: 0
  },
  mutations: {
    setDevice (state, n) {
      state.device = n
    },
    // setWindow (state) {
    //   state.windowWidth = document.documentElement.clientWidth
    // },
    setMenu (state, val = undefined) {
      state.downloadOpen = false
      state.menuOpen = (val === undefined) ? !state.menuOpen : val
    },
    setDownload (state, val = undefined) {
      state.menuOpen = false
      state.downloadOpen = (val === undefined) ? !state.downloadOpen : val
    },
    setMobileMenu (state, val) {
      state.isMobileMenu = val
    },
    setWidth (state, val = 0) {
      state.viewWidth = val
    },
    setPrimaryRouteName (state, val) {
      state.routeName = val
    },
    setVideo (state, val) {
      state.videoSrc = (typeof val === 'string') ? val : null
      state.videoOpen = (typeof val === 'string')
    },
    setContent (state, data) {
      state.content = data
    },
    setHeadHeight (state, val) {
      state.headHeight = val
    }
  },
  getters: {
    getSubPages (state) {
      return state.pages.filter(item => item.parent.name === state.routeName)[0] || false
    },
    getContent (state) {
      return (id) => state.content[id]
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js